import { UUID } from "crypto";
import { baseApi } from "./baseApi";
import { PldSearchResult, PldSearchResultRisk, PldSearchResultSumary } from "@interfaces/pld";
import { Response } from "@interfaces/response";

import SearchResultSummaryData from "../dataDummy/searchResultSumary.json";
import PldSearchResultData from "../dataDummy/pldSearchResult.json";

const pldApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        getPldSearchResults: build.query<Array<PldSearchResult>, UUID>({
            // query: (applicationId) => ({
            //     url: `pld/search_results`,
            //     params: {
            //         loan_application_id: applicationId,
            //     },
            // }),
            // transformResponse: (response: Response<Array<PldSearchResult>>) => {
            //     return response.data;
            // },

            async queryFn(args, _queryApi, _extraOptions, baseQuery) {
                if (args === "3912e960-7795-434f-bc47-d277ff43937e") {
                    return {
                        data: PldSearchResultData,
                    };
                }
                const result = await baseQuery({
                    url: `/pld/search_results`,
                    params: {
                        loan_application_id: args,
                    },
                });

                return result.data;
            },
        }),
        getPldSearchResultSumary: build.query<Array<PldSearchResultSumary>, UUID>({
            // query: (applicationId) => ({
            //     url: `pld/search_results_sumary`,
            //     params: {
            //         loan_application_id: applicationId,
            //     },
            // }),
            // transformResponse: (response: Response<Array<PldSearchResultSumary>>) => {
            //     return response.data;
            // },

            async queryFn(args, _queryApi, _extraOptions, baseQuery) {
                if (args === "3912e960-7795-434f-bc47-d277ff43937e") {
                    return {
                        data: SearchResultSummaryData,
                    };
                }
                const result = await baseQuery({
                    url: `/pld/search_results_sumary`,
                    params: {
                        loan_application_id: args,
                    },
                });

                return result.data;
            },
        }),
        getPldSearchResultRisk: build.query<PldSearchResultRisk, UUID>({
            query: (applicationId) => ({
                url: `pld/search_results_risk`,
                params: {
                    loan_application_id: applicationId,
                },
            }),
            transformResponse: (response: Response<PldSearchResultRisk>) => {
                return response.data;
            },
        }),
    }),
});

export const {
    useLazyGetPldSearchResultsQuery,
    useGetPldSearchResultsQuery,
    useLazyGetPldSearchResultSumaryQuery,
    useLazyGetPldSearchResultRiskQuery,
} = pldApi;
